<!-- eslint-disable no-tabs -->
<template>
	<div class="trabajos__content__grid trabajos__content__grid--desktop">
		<hooper
			class="row-odd"
			group="1"
			:items-to-show="5"
			:items-to-slide="1"
			:infinite-scroll="true"
			:wheel-control="false"
			:settings="hooperSettings"
      ref="trabajos"
		>
			<slide class="item" v-for="trabajo in grilla1" :key="trabajo.slug">
				<img class="item__cover" :src="trabajo.cover" @click="selectWork(trabajo)">
				<button class="expand" @click="selectWork(trabajo)">
					<img src="/img/png/expand.png" />
				</button>
			</slide>
		</hooper>
		<hooper
			class="row-even"
			group="1"
			:items-to-show="5"
			:items-to-slide="1"
			:infinite-scroll="true"
			:wheel-control="false"
			:settings="hooperSettings"
		>
			<slide class="item" v-for="trabajo in grilla2" :key="trabajo.slug">
				<img class="item__cover" :src="trabajo.cover" @click="selectWork(trabajo)">
				<button v-show="showButton(trabajo)" class="expand" @click="selectWork(trabajo)">
					<img src="/img/png/expand.png" />
				</button>
			</slide>
			<hooper-pagination slot="hooper-addons"></hooper-pagination>
		</hooper>

    <button @click="carouselPrev" class="prev">
      <font-awesome-icon :icon="['far', 'angle-left']" class="icon" />
    </button>
    <button @click="carouselNext" class="next">
      <font-awesome-icon :icon="['far', 'angle-right']" class="icon" />
    </button>
	</div>
</template>

<script>
import {
  Hooper,
  Slide,
  Pagination as HooperPagination
} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  props: {
    grilla1: {
      type: Array,
      required: true
    },
    grilla2: {
      type: Array,
      required: true
    }
  },
  components: {
    Hooper,
    Slide,
    HooperPagination
  },
  data () {
    return {
      selectedWork: null,
      allWorks: new Array(30),
      hooperSettings: {
        itemsToShow: 4,
        breakpoints: {
          1281: {
            itemsToShow: 4
          },
          1920: {
            itemsToShow: 5
          }
        }
      }
    }
  },
  methods: {
    onSwiper (swiper) {
      console.log('swiper: ', swiper)
    },
    selectWork (item) {
      this.$emit('select', item)
    },
    carouselNext () {
      this.$refs.trabajos.slideNext()
    },
    carouselPrev () {
      this.$refs.trabajos.slidePrev()
    },
    showButton (item) {
      return item.images.length > 0 || item.videos.length > 0
    }
  }
}
</script>
